import Web3Modal from "web3modal";
import { DeFiWeb3Connector } from 'deficonnect'
import WalletConnectProvider from "@walletconnect/web3-provider";
import WalletLink from "walletlink";
import ReactDOM from 'react-dom';
import $ from 'jquery';
import React, { useEffect, useState, useRef } from "react";
import Web3EthContract from "web3-eth-contract";
import { useDispatch, useSelector } from "react-redux";
import { fetchData } from "./redux/data/dataActions";


const ABI = 
[
	{
		"inputs": [
			{
				"internalType": "string",
				"name": "_name",
				"type": "string"
			},
			{
				"internalType": "string",
				"name": "_symbol",
				"type": "string"
			},
			{
				"internalType": "string",
				"name": "_initBaseURI",
				"type": "string"
			},
			{
				"internalType": "string",
				"name": "_initNotRevealedUri",
				"type": "string"
			}
		],
		"stateMutability": "nonpayable",
		"type": "constructor"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "owner",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "address",
				"name": "approved",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "uint256",
				"name": "tokenId",
				"type": "uint256"
			}
		],
		"name": "Approval",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "owner",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "address",
				"name": "operator",
				"type": "address"
			},
			{
				"indexed": false,
				"internalType": "bool",
				"name": "approved",
				"type": "bool"
			}
		],
		"name": "ApprovalForAll",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "previousOwner",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "address",
				"name": "newOwner",
				"type": "address"
			}
		],
		"name": "OwnershipTransferred",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "from",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "address",
				"name": "to",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "uint256",
				"name": "tokenId",
				"type": "uint256"
			}
		],
		"name": "Transfer",
		"type": "event"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "to",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "tokenId",
				"type": "uint256"
			}
		],
		"name": "approve",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "owner",
				"type": "address"
			}
		],
		"name": "balanceOf",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "baseExtension",
		"outputs": [
			{
				"internalType": "string",
				"name": "",
				"type": "string"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "cost",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "tokenId",
				"type": "uint256"
			}
		],
		"name": "getApproved",
		"outputs": [
			{
				"internalType": "address",
				"name": "",
				"type": "address"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "owner",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "operator",
				"type": "address"
			}
		],
		"name": "isApprovedForAll",
		"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "maxMintAmount",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "maxSupply",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "_mintAmount",
				"type": "uint256"
			}
		],
		"name": "mint",
		"outputs": [],
		"stateMutability": "payable",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "name",
		"outputs": [
			{
				"internalType": "string",
				"name": "",
				"type": "string"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "notRevealedUri",
		"outputs": [
			{
				"internalType": "string",
				"name": "",
				"type": "string"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "owner",
		"outputs": [
			{
				"internalType": "address",
				"name": "",
				"type": "address"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "tokenId",
				"type": "uint256"
			}
		],
		"name": "ownerOf",
		"outputs": [
			{
				"internalType": "address",
				"name": "",
				"type": "address"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "bool",
				"name": "_state",
				"type": "bool"
			}
		],
		"name": "pause",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "paused",
		"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "renounceOwnership",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "reveal",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "revealed",
		"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "from",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "to",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "tokenId",
				"type": "uint256"
			}
		],
		"name": "safeTransferFrom",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "from",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "to",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "tokenId",
				"type": "uint256"
			},
			{
				"internalType": "bytes",
				"name": "_data",
				"type": "bytes"
			}
		],
		"name": "safeTransferFrom",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "operator",
				"type": "address"
			},
			{
				"internalType": "bool",
				"name": "approved",
				"type": "bool"
			}
		],
		"name": "setApprovalForAll",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "string",
				"name": "_newBaseExtension",
				"type": "string"
			}
		],
		"name": "setBaseExtension",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "string",
				"name": "_newBaseURI",
				"type": "string"
			}
		],
		"name": "setBaseURI",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "_newCost",
				"type": "uint256"
			}
		],
		"name": "setCost",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "string",
				"name": "_notRevealedURI",
				"type": "string"
			}
		],
		"name": "setNotRevealedURI",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "_newmaxMintAmount",
				"type": "uint256"
			}
		],
		"name": "setmaxMintAmount",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "bytes4",
				"name": "interfaceId",
				"type": "bytes4"
			}
		],
		"name": "supportsInterface",
		"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "symbol",
		"outputs": [
			{
				"internalType": "string",
				"name": "",
				"type": "string"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "index",
				"type": "uint256"
			}
		],
		"name": "tokenByIndex",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "owner",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "index",
				"type": "uint256"
			}
		],
		"name": "tokenOfOwnerByIndex",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "tokenId",
				"type": "uint256"
			}
		],
		"name": "tokenURI",
		"outputs": [
			{
				"internalType": "string",
				"name": "",
				"type": "string"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "totalSupply",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "from",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "to",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "tokenId",
				"type": "uint256"
			}
		],
		"name": "transferFrom",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "newOwner",
				"type": "address"
			}
		],
		"name": "transferOwnership",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "_owner",
				"type": "address"
			}
		],
		"name": "walletOfOwner",
		"outputs": [
			{
				"internalType": "uint256[]",
				"name": "",
				"type": "uint256[]"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "withdraw",
		"outputs": [],
		"stateMutability": "payable",
		"type": "function"
	}
]

const NFTCONTRACT = "0x230Bb7ce185CD0042973202f5F38B7072440e2C9";

const providerOptions = {
    display: {
        logo: "",
        name: "Defi Wallet",
        description: "Connect to your Defi Wallet account"
    },
    package: DeFiWeb3Connector,
    options: {
        supportedChainIds: [1, 25],
        rpc: {
            1: "https://mainnet.infura.io/v3/c66d5493eff848ca89349923e7d1131a",
            25: "https://evm.cronos.org/", // cronos mainet
        },
        pollingInterval: 15000,
    },

    walletconnect: {
        package: WalletConnectProvider, // required
        options: {
            infuraId: "c66d5493eff848ca89349923e7d1131a", // required
            rpc: {
                1: "https://mainnet.infura.io/v3/c66d5493eff848ca89349923e7d1131a",
                25: "https://evm.cronos.org/", // cronos mainet
            },
        },
    },
    walletlink: {
        package: WalletLink, // Required
        options: {
            appName: "Ava Sharks", // Required
            infuraId: "c66d5493eff848ca89349923e7d1131a", // Required unless you provide a JSON RPC url; see `rpc` below
            rpc: "https://mainnet.infura.io/v3/c66d5493eff848ca89349923e7d1131a", // Optional if `infuraId` is provided; otherwise it's required
            chainId: 25, // Optional. It defaults to 1 if not provided
            appLogoUrl: null, // Optional....
        },
    },
}


    const web3Modal = new Web3Modal({
        network: "mainnet",
        providerOptions
    });

const Marketplace = () => {
    const [showModal, setShowModal] = useState(false);
    const [account, setAccount] = useState("");
    const [smartContract, setSmartContract] = useState(null);
    const [connector, setConnector] = useState(null);
    const [balances, setBalances] = useState({});
	const blockchain = useSelector((state) => state.blockchain);
	const data = useSelector((state) => state.data);

    const connect = () => {
        const provider = new Web3Modal({
            network: "mainnet", // optional
            cacheProvider: true, // optional
            providerOptions: providerOptions, // required
        });
        provider
            .connect()
            .then(async (c) => {
                setConnector(c);
                const web3 = new Web3(c);
				const accounts = await web3.eth.getAccounts();
				console.log(accounts);
				setAccount(accounts[0]);
				console.log(accounts[0]);
                
				const contract = new Web3EthContract(ABI, NFTCONTRACT);
                setSmartContract(contract);
                fetchData(accounts[0]);
            })
            .catch((error) => {
                console.error(error);
            });
    }

    const isConnected = () => {
        return connector !== null && account !== "";
    };

    const logout = () => {
        setAccount("");
        setSmartContract(null);
        setConnector(null);
	};

	function addIPFSProxy(ipfsHash) {
		const URL = "https://idm.infura-ipfs.io/ipfs/"
		const hash = ipfsHash.replace(/^ipfs?:\/\//, '')
		const ipfsURL = URL + hash

		console.log(ipfsURL)
		return ipfsURL
	}
    /*async function fetchBalances() {
		const contract = new Web3EthContract(ABI, NFTCONTRACT);
		const address = blockchain.account;
        // Fetch the total number of NFTs held by the user
        const totalNFTs = await contract.methods.balanceOf(blockchain.account).call();
        console.log(`Total NFTs held by the user: ${totalNFTs}`);

        let nfts = [];

        // Loop through all of the NFTs held by the user
        for (let i = 0; i < totalNFTs; i++) {
            if (i === 10) {
                break;
            }

            // Get the token ID for the current NFT
            const tokenId = await contract.methods.tokenOfOwnerByIndex(address, i).call();
            console.log(`Token ID: ${tokenId}`);

            // Get the NFT metadata and image URI
            const uri = await contract.methods.tokenURI(tokenId).call();
            const ipfsURL = addIPFSProxy(uri);
            const request = new Request(ipfsURL);
            const response = await fetch(request);
            const metadata = await response.json();
            console.log(`NFT Metadata: ${metadata}`);

            const image = addIPFSProxy(metadata.image);
            console.log(`Image URL: ${image}`);

            // Add the NFT information to the array
            nfts.push({
                tokenId: tokenId,
                metadata: metadata,
                image: image
            });

            console.log(nfts);
		}

		return (
			<div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '20px' }}>
				{nfts.map(nft => (
					<div key={nft.id} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
						<img src={nft.image} alt={nft.tokenId} style={{ width: '100px', height: '100px' }} />
						<div>{nft.name}</div>
					</div>
				))}
			</div>

		);
    }





    return (
        <div>
            {isConnected() ? (
                <div>
                    <p>You are currently connected!</p>
                    <button onClick={logout}>Logout</button>
                </div>
            ) : (
                <div>
                    <p>You are not connected.</p>
                    <button onClick={connect}>Connect Wallet</button>
                </div>
			)}

			<button onClick={fetchBalances}>NFTS</button>

        </div>



    );
};

export default Marketplace;

*/

	async function fetchBalances() {

		const contract = new Web3EthContract(ABI, NFTCONTRACT)
		const address = blockchain.account;


		let totalNFTs = 0;
		let nfts = [];


		// Get the total number of NFTs held by the user
		totalNFTs = await contract.methods.balanceOf(address).call();
		console.log('totalNFTs:', totalNFTs);
		// Loop through all of the NFTs held by the user



		for (let i = 0; i < totalNFTs; i++) {

			if (i === 10) {
				break;
			}
			// Get the token ID for the current NFT
			const tokenId = await contract.methods.tokenOfOwnerByIndex(address, i).call();
			console.log('tokenId:', tokenId);
			// Get the NFT metadata and image URI
			const uri = await contract.methods.tokenURI(tokenId).call();
			const ipfsURL = addIPFSProxy(uri);
			const request = new Request(ipfsURL);
			const response = await fetch(request);
			const metadata = await response.json();
			console.log(metadata.name); // Metadata in JSON

			const image = addIPFSProxy(metadata.image);
			let jsonData = {};
			console.log('uri:', uri);
			console.log(metadata);
			console.log(metadata.artist);
			console.log(image);


			let jsonString = JSON.stringify(uri.replace(/ipfs:\/\//g, "https://"));

			jsonData = JSON.parse(jsonString);
			console.log(jsonData);



			let name = addIPFSProxy(metadata.name);
			console.log(metadata.name);
			let description = addIPFSProxy(metadata.description);
			console.log(description)


			// Add the NFT information to the array
			nfts.push({
				tokenId: tokenId,
				metadata: metadata,
				image: image,

			});
			console.log(nfts);

			// Build and display the HTML element for each NFT
			// Build and display the HTML element for each NFT
			let content = `
			<div class="card col-md-3">
			  <img src="${image}" class="card-img-top" width=300 height=300>
			  <div class="card-body">
				<h5 class="card-title">${metadata.name}</h5>
				<p class="card-text">${metadata.description}</p>
				<button type="button" class="btn btn-primary stake-btn zoom" data-tokenid="${tokenId}">Stake</button>
				

			  </div>

			  <style>
  .card {
    background-color: #fff;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    border: 1px solid #ccc;
    margin-bottom: 20px;
  }

  .zoom {
    transition: transform 0.5s ease;
  }

  .zoom:hover {
    transform: scale(1.1);
  }

  .btn {
    transition: background-color 0.5s ease;
    color: #fff;
  }

  .btn:hover {
    background-color: #1f87f5;
  }

  #stakeBtn, #unstakeBtn, #claimBtn {
    position: relative;
  }

  #stakeBtn:after, #unstakeBtn:after, #claimBtn:after {
    content: '';
    display: block;
    width: 30px;
    height: 30px;
    border: 2px solid #fff;
    border-top: 2px solid transparent;
    border-radius: 50%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(0deg);
    animation: rotate 1s infinite linear;
  }

  @keyframes rotate {
    0% {
      transform: translate(-50%, -50%) rotate(0deg);
    }
    100% {
      transform: translate(-50%, -50%) rotate(360deg);
    }
  }

  #stakeBtn.loading:after, #unstakeBtn.loading:after, #claimBtn.loading:after,
</style>
			</div>
			`;

			document.getElementById("nftid").innerHTML += content;

		}


		return nfts;
		setNfts(nfts);

	}

	const getData = () => {
		if (blockchain.account !== "" && blockchain.smartContract !== null) {
			dispatch(fetchData(blockchain.account));
		}
	};

	

	

	useEffect(() => {
		getData();
	}, [blockchain.account]);

	return (
		<div>
			{isConnected() ? (
				<div>
					<p>You are currently connected!</p>
					<button onClick={logout}>Logout</button>
				</div>
			) : (
				<div>
					<p>You are not connected.</p>
					<button onClick={connect}>Connect Wallet</button>
				</div>
			)}

			<button onClick={fetchBalances}>NFTS</button>

		</div>



	);
}

export default Marketplace;